export enum UserRightsActions {
  readTemplate = 'ReadTemplate',
  addTemplate = 'AddTemplate',
  updateTemplate = 'UpdateTemplate',
  deleteTemplate = 'DeleteTemplate',
  assignTemplate = 'AssignTemplate',
  duplicateTemplate = 'DuplicateTemplate',
}
